import type { ChatAttachmentRef } from '@/components/agent-chat';

export interface ChatHomeLocationState {
  chatDraft?: string;
  autoSend?: boolean;
  attachments?: ChatAttachmentRef[];
  startedNewConversation?: boolean;
}

export const NEW_CHAT_LOCATION_STATE: ChatHomeLocationState = {
  startedNewConversation: true,
};
